import { BREAKPOINTS_PX } from '@badi/badi-components';

export const QUERIES = [`(min-width: ${BREAKPOINTS_PX.lg})`];

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';
